export default "__VITE_ASSET__CfN6yARL__"